<template>
  <div id="app">
    <Header v-if="showHeaderFooter"/>
    <router-view class="main-content"/>
    <Footer v-if="showHeaderFooter"/>
    <MessageNotification ref="messageNotification"/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import MessageNotification from './components/MessageNotification.vue'

export default {
  name: 'App',
  
  components: {
    Header,
    Footer,
    MessageNotification
  },

  computed: {
    showHeaderFooter() {
      return !this.$route.path.includes('/login') && !this.$route.path.includes('/workspace')
    }
  },

  methods: {
    showMessage(message) {
      this.$refs.messageNotification.addMessage(message)
    }
  }
}
</script>

<style>
@import './assets/styles/global.css';
@import './assets/styles/dark-theme.css';

body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}
</style>